export const enUS = {
  translation: {
    header: {
      title: "Hello",
      tips_one: "The page has been viewed {{count}} time",
      tips_other: "The page has been viewed {{count}} times",
      tips_zero: "No views yet",
    },
    date: "Today is {{date, DATE_HUGE}}",
  },
};
